const getComponentIsDeprecatedMsg = ({
  deprecatedComponent,
  newComponentToUseInstead,
  formatAsJsx,
}: {
  deprecatedComponent: string;
  newComponentToUseInstead?: string;
  formatAsJsx?: boolean;
}) => {
  if (formatAsJsx) {
    return `<${deprecatedComponent} /> is deprecated.${
      newComponentToUseInstead ? ` Please use <${newComponentToUseInstead} /> instead.` : ''
    } See WRITING.md in docs site for help.`;
  }
  return `The component ${deprecatedComponent} is deprecated.${
    newComponentToUseInstead ? ` Please use ${newComponentToUseInstead} instead.` : ''
  } See WRITING.md in docs site for help.`;
};

export default getComponentIsDeprecatedMsg;
